
const app = {
  state: {
    snackbar: { color: 'success', show: false, text: '' }
  },

  mutations: {
    CLOSED_SNACKBAR: (state) => {
      state.snackbar.show = false
    },
    SHOW_SNACKBAR: (state, content) => {
      state.snackbar = content
    }
  },

  actions: {
    closedSnackbar({ commit }) {
      commit('CLOSED_SNACKBAR')
    },
    showSnackbar({ commit }, content) {
      commit('SHOW_SNACKBAR', content)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js